import React from 'react';
import styled from 'styled-components';

interface AdminMemberInfoProps {
  label: string;
  value: string;
  href?: string;
}

const AdminMemberInfo: React.FC<AdminMemberInfoProps> = ({
  label,
  value,
  href,
}) => {
  return (
    <Info>
      <InfoLabel>{label}:</InfoLabel>
      <InfoValue>
        {href ? (
          <InfoLink
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {value}
          </InfoLink>
        ) : value}
      </InfoValue>
    </Info>
  );
};

const Info = styled.div`
  min-height: 18px;
  padding-right: 4px;
  margin-bottom: 1px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  ${({ theme }) => theme.typography.Body_04};
`;

const InfoLabel = styled.span`
  flex-shrink: 0;
  min-width: 140px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  font-weight: 500;
`;

const InfoValue = styled.span`
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => theme.colors.color_Gray_01};
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.2;
`;

const InfoLink = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  word-break: break-word;
  overflow-wrap: anywhere;

  &:hover {
    text-decoration: underline;
  }
`;

export default AdminMemberInfo;
